<template>
  <div class="barrery-outer">
    <div class="batteryCompartment">
      <div class="batteryOuter" v-for="i in list" :key="i">
        <div class="batteryText">{{i.name}}</div>
        <div class="batteryValue">{{i.value}}</div>
      </div>
    </div>
  </div>
</template>
<script>
//饼图
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      list:[{
        'name':'工作状态',
        'value':''
      },{
        'name':'告警状态',
        'value':''
      },{
        'name':'充电开始时间',
        'value':''
      },{
        'name':'已经充电时间(min)',
        'value':''
      },{
        'name':'充电开始SOC(%)',
        'value':''
      },{
        'name':'当前SOC(%)',
        'value':''
      },{
        'name':'充电开始SOE(kWh)',
        'value':''
      },{
        'name':'当前SOE(kWh)',
        'value':''
      },{
        'name':'当前充电电压(V)',
        'value':''
      },{
        'name':'当前充电电流(A)',
        'value':''
      }]
    };
  },
  components: {
  },
  watch: {
    
  },

  methods: {
    getData(data){
      this.chongdianji(data);
    },
    chongdianji(data){
      let params = {
        'enCode':'TiDB-dianchixiang-chongdianguochengchongdianjixinx',
        '@battery_id':data.batteryId
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log("充电机信息",res)
					this.list=[{
        'name':'工作状态',
        'value':res&&res.work_status
      },{
        'name':'告警状态',
        'value':res&&res.alarm_status
      },{
        'name':'充电开始时间',
        'value':res&&res.recording_time
      },{
        'name':'已经充电时间(min)',
        'value':res&&res.recording_end_time
      },{
        'name':'剩余充电时间',
        'value':res&&res.remaining_charging_time
      },{
        'name':'当前SOC(%)',
        'value':res&&res.current_soc
      },{
        'name':'仓位号',
        'value':res&&res.position_no
      },{
        'name':'当前SOE(kWh)',
        'value':res&&res.current_remaining_power
      },{
        'name':'当前充电电压(V)',
        'value':res&&res.chg_output_volt
      },{
        'name':'当前充电电流(A)',
        'value':res&&res.chg_output_curr
      }]
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.barrery-outer{
  width:100%;
}
.batteryCompartment{
	display: grid;
	grid-template-columns: repeat(5, 19%);
	// grid-template-rows: 60px 60px 60px 60px 60px;
	// justify-content: space-between;
  grid-row-gap: 30px;
  grid-column-gap: 26px;
	.batteryOuter{
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    .batteryText{
		  background: rgba(1,177,169,0.30);
      height:30px;
      line-height: 30px;
      border-bottom: 1px solid #086D6A;
    }
    .batteryValue{
		  height:30px;
      line-height: 30px;
    }
	}
}
</style>
